import { Component, OnDestroy, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { take, switchMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { TokenAcesso } from 'app/model/tokenAcesso';
import { User } from 'app/model/user';
import { UsuariosService } from 'app/api/usuarios.service';
import { AlertModalService } from 'app/shared/alert-modal.service';
import { LanguageDataTable } from 'app/shared/datatable/translate-datatable';
import { DataTableDirective } from 'angular-datatables';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-integracoes',
  templateUrl: './integracoes.component.html',
  styleUrls: ['./integracoes.component.css']
})

export class IntegracoesComponent implements OnInit, OnDestroy {

  usuarioLogado: User;
  tokens: TokenAcesso[];
  idUsuario: string;

  displayTokenModal = '';
  descricaoTokenModal = '';
  linkCopiado: boolean = false;
  carregando = false;

  gerarTokenForm: FormGroup;

  private subs = new SubSink();

  @ViewChild(DataTableDirective, {static: false})
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  orderCondition: number = 3;
  order = 'createdAt';
  reverse = true;
  public paginaAtual = 1;
  public itensPorPagina = 25;

  constructor(
    private usuariosService: UsuariosService,
    private route: ActivatedRoute,
    private location: Location,
    private formBuilder: FormBuilder,
    private alertService: AlertModalService) {

      this.gerarTokenForm = this.formBuilder.group({
        descricao: ['', Validators.required],
        expiraEm: ['', Validators.required],
        plataformaIntegrada: ['Plooral']
        // escopos: ['']
      });

     }

  ngOnInit() {
    this.idUsuario = null;
    this.getUsuarioLogado();
    this.startDataTable();

    this.gerarTokenForm.patchValue({ plataformaIntegrada: 'Plooral' });

  }

  startDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      processing: true,
      responsive: true,
      order: [[this.orderCondition, "desc"]],
      language: LanguageDataTable.portugues_datatables
    };
  }

  getUsuarioLogado() {
    this.subs.sink = this.usuariosService.v1UsuariosLogadoGet()
    .subscribe(
      usuarioLogado => {
        this.usuarioLogado = usuarioLogado;
        this.getUsuario();
      }
    );
  }

  getUsuario() {
      this.idUsuario = this.usuarioLogado.id; 
      this.getToken()
  }

  getToken() {
    this.tokens = [];
    this.carregando = true;
    if (this.idUsuario) {
      this.subs.sink = this.usuariosService.v1UsuariosLogadoTokenGet()
      .subscribe(
        tokens => {
          this.tokens = tokens;
          this.carregando = false;
        }
      );
    }
  }


  gerarToken(): void {
    this.usuariosService.v1UsuariosLogadoTokenPost(this.gerarTokenForm.value)
    .subscribe(success => {
      this.alertService.showAlertSuccess('Token gerado com sucesso!');
      this.resetFormToken();
      this.getToken();
    }, error => {
        console.error("Erro:", error);
        if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
          this.alertService.showAlertDanger(error.Erros[0].Mensagem);
        } else {
          this.alertService.showAlertDanger('Erro ao gerar Token. Tente novamente mais tarde.');
        }
    });
    
  }

  onCancelToken(idToken) {
    const result$ = this.alertService.showConfirm('Confirmação', 'Tem certeza que deseja revogar este Token?');
    result$.asObservable()
      .pipe(
        take(1),
        switchMap(result => {
          if (result) { 
            return this.usuariosService.v1UsuariosLogadoTokenIdDelete(idToken);
          } else {
            return EMPTY;
          }
        })
      )
      .subscribe(
        success => {
          this.alertService.showAlertSuccess('Token revogado com sucesso!');
          this.getToken();
        },
        error => {
          console.error("Erro:", error);
          if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
            this.alertService.showAlertDanger(error.Erros[0].Mensagem);
          } else {
            this.alertService.showAlertDanger('Erro ao revogar o Token. Tente novamente mais tarde.');
          }
        }
      );
  }

  configTokenModal(token, name){

    this.displayTokenModal = token;
    this.descricaoTokenModal = name;

    document.getElementById('btnViewTokenModal').click();
    (document.getElementById('inputTokenModal') as HTMLInputElement).value = this.displayTokenModal;

  }

  copyInputMessage(inputElement){
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.linkCopiado = true;

    setTimeout(() => {this.linkCopiado = false}, 2000);
  }


  goBack(): void {
    this.location.back();
  }

  resetFormToken() {
    this.gerarTokenForm.reset();
    this.gerarTokenForm.patchValue({ plataformaIntegrada: 'Plooral' });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}


